<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3" vi-if="inputs.length">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.disabled" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="disabled" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.readonly" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="readonly" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.hint" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="hint" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.error" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="error" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.required" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="required" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.clearable" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="clearable" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="8" md12 sm24 v-for="(input, index) in inputs" :key="index">
        <card>
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" v-html="firstLetterCapital(input.type) || $lang.multiline" />
          <card-text>
            <text-field
              @left-icon-click="onIconClick('left')"
              @right-icon-click="onIconClick('right')"
              v-model="value"
              :color="$root.$colors.primary"
              :color-lightness="$root.$colors.bgColorLightness"
              :icon-left="input.iconLeft"
              :icon-right="input.iconRight"
              :multiline="input.multiline"
              :label="$lang.inputLabel"
              :placeholder="$lang.inputPlaceholder"
              :type="input.type"
              :reveal="input.type === 'password'"
              :hint="hint ? $lang.hintText.toLowerCase() : null"
              :error="error ? $lang.errorText.toLowerCase() : null"
              :hint-color="$dark ? 'white' : 'black'"
              :hint-color-lightness="null"
              :clearable="clearable"
              :label-color="$dark ? 'white' : 'black'"
              :label-color-lightness="null"
              :required="required"
              :readonly="readonly"
              :disabled="disabled" />
          </card-text>
          <card-actions align="center">
            <code-chunk :pre="false">v-model: {{ value }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageTextField',
  mixins: [
    methods
  ],
  data () {
    return {
      error: false,
      hint: false,
      required: false,
      disabled: false,
      readonly: false,
      clearable: true,
      value: null,
      inputs: []
    }
  },
  mounted () {
    this.getExternalData('text-field.json', 'inputs')
  },
  methods: {
    onIconClick (icon) {
      this.log(`${icon}-icon-click`, 'text-field', `${icon} icon clicked`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/text-field.vue